import { StoryObj, Meta } from '@storybook/react';
import { ProductCard } from './ProductCard';

export default {
	title: 'Molecules/Card/ProductCard',
	component: ProductCard,
} as Meta;

type Story = StoryObj<typeof ProductCard>;

export const Default: Story = {
	args: {
		columnWidth: '50',
		imageSizes: '(max-width: 768px) 50vw, 50vw',
		product: {
			id: '1',
			name: 'productName',
			price: 400,
			category: 'category',
			image: {
				url: 'https://picsum.photos/300/300',
				properties: {
					altText: 'Alternative text',
				},
			},
			link: {
				url: '#',
				name: 'Gå til produktet',
			},
			variants: [
				{
					id: '1',
					type: 'sizes',
					name: 'S',
					price: 152,
					quantity: 3,
				},
			],
		},
	},
};

export const ManyVariants: Story = {
	args: {
		...Default.args,
		product: {
			id: '2',
			name: 'Produkt1',
			price: 1055,
			category: 'Clothing',
			image: {
				url: 'https://picsum.photos/300/300',
				properties: {
					altText: 'Alternative text',
				},
			},
			link: {
				name: 'Gå til produktet',
				url: '#',
			},
			variants: [
				{
					id: '2',
					type: 'sizes',
					name: 'S',
					price: 152,
					quantity: 3,
				},
				{
					id: '21',
					type: 'sizes',
					name: 'M',
					price: 452,
					quantity: 5,
				},
				{
					id: '22',
					type: 'sizes',
					name: 'L',
					price: 652,
					quantity: 0,
				},
				{
					id: '23',
					type: 'sizes',
					name: 'XL',
					price: 1552,
					quantity: 5,
				},
				{
					id: '24',
					type: 'sizes',
					name: 'XXL',
					price: 22,
					quantity: 5,
				},
			],
		},
	},
};

export const FewVariants: Story = {
	args: {
		...Default.args,
		product: {
			id: '3',
			name: 'Produkt1',
			price: 155,
			category: 'Clothing',
			image: {
				url: 'https://picsum.photos/300/300',
				properties: {
					altText: 'Alternative text',
				},
			},
			link: {
				name: 'Gå til produktet',
				url: '#',
			},
			variants: [
				{
					id: '3',
					type: 'sizes',
					name: 'S',
					price: 152,
					quantity: 3,
				},
				{
					id: '31',
					type: 'sizes',
					name: 'M',
					price: 452,
					quantity: 5,
				},
				{
					id: '32',
					type: 'sizes',
					name: 'L',
					price: 652,
					quantity: 0,
				},
			],
		},
	},
};

export const SoldOut: Story = {
	args: {
		...Default.args,
		product: {
			id: '4',
			name: 'Produkt1',
			price: 550,
			category: 'Clothing',
			image: {
				url: 'https://picsum.photos/300/300',
				properties: {
					altText: 'Alternative text',
				},
			},
			link: {
				name: 'Gå til produktet',
				url: '#',
			},
			variants: [
				{
					id: '41',
					type: 'sizes',
					name: 'S',
					price: 152,
					quantity: 0,
				},
				{
					id: '42',
					type: 'sizes',
					name: 'M',
					price: 452,
					quantity: 0,
				},
				{
					id: '43',
					type: 'sizes',
					name: 'L',
					price: 652,
					quantity: 0,
				},
			],
		},
	},
};
